import { cloneElement } from 'react'

import { useExpandableTextContext } from './ExpandableText'
import type { ExpandableTextTriggerProps } from './types'

export const Trigger = ({ children, ...props }: ExpandableTextTriggerProps) => {
  const { isExpanded, onToggle, textId } = useExpandableTextContext()

  return cloneElement(
    typeof children === 'function'
      ? children({ isExpanded, onToggle, textId })
      : children,
    {
      'aria-expanded': isExpanded,
      'aria-controls': textId,
      onClick: onToggle,
      ...props,
    },
  )
}
